<template>
    <b-row align-v="center" class="vh-100 text-center">
        <b-col>
            <b-spinner></b-spinner>
            <span class="h4"> Chargement</span>
        </b-col>
    </b-row>
</template>

<script>
export default {
  name: 'Init',
  async mounted () {
    try {

        // Effectue un await sur le axios afin d'attendre la réponse pour la poursuite du code
        const response = await this.$axios
            .get(this.$config.API + '/init-token', {
                headers: {
                    'Authorization': null
                }
            });
        // Déclenchement du catch
        if (response.data === null) {
            throw 'Pas de token'
        }

        // Sauvegarde le token, mais uniquement lorsque l'axios a terminé son get
        this.$store.token = response.data.token;

        // Temporise volontairement avant de rediriger vers Accueil pour laisser entrevoir l'animation de chargement
        setTimeout(() => {
            // Lève la phase d'initialisation (fera afficher les header et footer dans App.vue)
            this.$store.init = false
            // Redirige vers accueil
            this.$actions.router('Accueil')
        }, 1500)
    } catch (e) {
        console.log(e)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Init.vue